import development from './dev';
import production from './prod';
import staging from './staging';
import test from './test_env';

export const useStagingApi = () =>
  import.meta.env.DEV && import.meta.env.VITE_USE_STAGING_API === 'true';

export type Environment = 'development' | 'staging' | 'production' | 'test';

type Dash0Config = {
  serviceName: string;
  environment: string;
  endpoint: {
    url: string;
    authToken: string;
    dataset?: string;
  };
  propagateTraceHeadersCorsURLs?: readonly RegExp[];
};

type Config = (
  | typeof development
  | typeof production
  | typeof staging
  | typeof test
) & { dash0?: Dash0Config };

const environmentLookup: Record<Environment, Config> = {
  development,
  test,
  staging,
  production,
};

const modeLookup: Record<string, Environment> = {
  'app.crossbeam.com': 'production',
  'cp-testing.netlify.app': 'staging',
  'app.crossbeam-dev.com': 'development',
};

const useStaging = useStagingApi();

function detectEnvironment(): Environment {
  if (import.meta.env.MODE === 'test') return 'test';

  const hostname = window?.location?.hostname ?? '';
  if (hostname.endsWith('app.cb.c7m.io') || useStaging) {
    return 'staging';
  }

  return modeLookup[hostname] ?? 'development';
}

const mode = detectEnvironment();

const appConfig: Config & { datadog?: unknown } = environmentLookup[mode];

if (useStaging) {
  console.info('Using staging API endpoints');
  delete appConfig.datadog;
  delete appConfig.dash0;
}

export default appConfig;
